export default __webpack_public_path__ + "img/ic-payments.5f84972e.svg";